<template>
  <section
      v-if="selectedPerson && Object.keys(selectedPerson).length > 0"
      class="grid grid-cols-[auto_1fr] gap-8 w-full"
  >
    <section class="flex flex-col gap-6 sticky top-0">
      <card padding="" class="flex flex-col h-fit">
        <div class="flex flex-row justify-between items-center px-8 py-4 border-b border-gray-400/50">
          <span class="font-bold">
            Dados Pessoais
          </span>

          <div class="flex flex-row gap-2">
            <rpm-button
                color="transparent"
                icon="fa-solid fa-pen-to-square"
                @click="personalDataModalOpen = true"
            ></rpm-button>
            <rpm-button
                color="transparent"
                icon="fa-solid fa-key"
                v-if="selectedPerson.user && $can('user.change_password')"
                @click="passwordModalOpen = true"
            ></rpm-button>
            <rpm-button
                color="transparent"
                icon="fa-solid fa-building"
                @click="toFunctions"
                v-if="selectedPerson.collaborator && $can('organizational.collaborator_functions.update')"
            ></rpm-button>
          </div>
        </div>

        <div class="flex flex-col gap-2 p-6 text-sm">
          <span v-if="selectedPerson.name" class="flex flex-row gap-2">
            <b>Nome:</b>
            {{ selectedPerson.name }}
          </span>

          <span v-if="selectedPerson.mobile" class="flex flex-row gap-2">
            <b>Contato:</b>
            {{ selectedPerson.mobile }}
          </span>

          <span v-if="selectedPerson.birthday" class="flex flex-row gap-2">
            <b>Nascimento:</b>
            {{ formatDate(selectedPerson.birthday) }}
          </span>

          <span v-if="selectedPerson.email" class="flex flex-row gap-2">
            <b>Email:</b>
            {{ selectedPerson.email }}
          </span>

          <span v-if="['F', 'J'].includes(selectedPerson.type)" class="flex flex-row gap-2">
            <b>Pessoa:</b>
            {{ selectedPerson.type === 'F' ? 'Física' : 'Jurídica' }}
          </span>
        </div>
      </card>

      <card padding="" class="flex flex-col h-fit">
        <div class="flex flex-row justify-between items-center border-b border-gray-400/50 px-8 py-4">
          <span class="font-bold">
            Endereço
          </span>

          <rpm-button
              color="transparent"
              :icon="`fa-solid ${selectedPerson.address ? ' fa-pen-to-square' : 'fa-plus'}`"
              @click="addressModalOpen = true"
          ></rpm-button>
        </div>
        <div class="flex flex-col gap-2 p-6 text-sm">

          <span v-if="selectedPerson.address && selectedPerson.address.neighborhood.state" class="flex flex-row gap-2">
            <b>Estado:</b>
            {{ selectedPerson.address.neighborhood.state }}
          </span>

          <span v-if="selectedPerson.address && selectedPerson.address.neighborhood.city" class="flex flex-row gap-2">
            <b>Cidade:</b>
            {{ selectedPerson.address.neighborhood.city }}
          </span>

          <span v-if="selectedPerson.address && selectedPerson.address.neighborhood.name" class="flex flex-row gap-2">
            <b>Bairro:</b>
            {{ selectedPerson.address.neighborhood.name }}
          </span>

          <span v-if="selectedPerson.address && selectedPerson.address.address" class="flex flex-row gap-2">
            <b>Rua:</b>
            {{ selectedPerson.address.address }}
          </span>

          <span v-if="selectedPerson.address && selectedPerson.address.number" class="flex flex-row gap-2">
            <b>Número:</b>
            {{ selectedPerson.address.number }}
          </span>

          <span v-if="selectedPerson.address && selectedPerson.address.complement" class="flex flex-row gap-2">
            <b>Complemento:</b>
            {{ selectedPerson.address.complement }}
          </span>

          <span
              v-if="selectedPerson.address && selectedPerson.address.neighborhood.reference_point"
              class="flex flex-row gap-2"
          >
            <b>Ponto De Referência:</b>
            {{ selectedPerson.address.neighborhood.reference_point }}
          </span>

          <span
              v-if="selectedPerson.address && selectedPerson.address.neighborhood.zipcode"
              class="flex flex-row gap-2"
          >
            <b>Cep:</b>
            {{ selectedPerson.address.neighborhood.zipcode }}
          </span>

        </div>
      </card>
    </section>

    <div class="flex flex-col gap-2">
      <router-view></router-view>

      <rpm-card-list
          :data="services"
          :pagination="pagination"
          @change-page="getServices"
          :loading="servicesLoading"
          grid-class="grid xl:grid-cols-2 grid-cols-1 gap-6"
          card-class="xl:last:odd:col-span-2"
      >
        <template #badges="{ item: service }">
          <badge class="bg-theme">{{ service.id }}</badge>
          <badge text-size="text-xxs" :color="service.service_priority.color">{{
              service.service_priority.name
            }}
          </badge>
          <badge text-size="text-xxs" color="#344767">{{ service.service_status.name }}</badge>
        </template>

        <template #actions="{ item: service }">
          <rpm-button
              tooltip-text="cancelar"
              padding=""
              color="transparent"
              icon="fa-solid fa-circle-xmark text-red-500"
              @click="modalOpen(service)"
              v-if="service.can_be_canceled && $can('services.service.cancel')"
          ></rpm-button>

          <rpm-button
              tooltip-text="executar"
              padding=""
              color="transparent"
              :to="{name: 'ServicesExecution', params: { service_id: service.id }}"
              icon="fa-solid fa-square-up-right"
          ></rpm-button>
        </template>

        <template #info="{ item: service }">
          <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-1">
              <span class="font-bold">{{ service.source_service.name_format }}</span>
              <span class="text-sm">
                <b>Solicitado via:</b>
                {{ service.attendance_channel.name }}, dia {{ formatDate(service.started_at) }}
              </span>
            </div>
            <div class="p-2 flex flex-col">
              <div class="grid grid-cols-[auto_1fr]" v-for="(procedure, idx) in service.procedures">
                <div class="grid grid-rows-[1rem_1fr]">
                  <div class="w-4 h-4 bg-transparent border-2" :class="timeLineNode(procedure, idx)"></div>
                  <div v-if="idx < service.procedures.length-1" class="flex flex-col items-center w-4">
                    <div class="w-px bg-gray-500/50 h-full"></div>
                  </div>
                </div>

                <span class="ml-2 flex flex-row gap-1 row-span-2"
                      :class="idx < service.procedures.length-1 ? 'mb-4':''">
                  {{ procedure.source_procedure.name }}

                  <badge
                      class="bg-theme/10 border border-theme"
                      text-size="text-xxs"
                      text-color="text-theme"
                      padding="px-1 py-0.5"
                  >
                    {{ procedure.id }}
                  </badge>
                </span>

                <div v-if="idx < service.procedures.length-1" class="flex flex-col items-center w-4">
                  <div class="w-px bg-gray-500/50 min-h-[10px] h-full"></div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </rpm-card-list>
    </div>

  </section>

  <cancel-service-modal
      :service="selectedService"
      :open="openModal"
      @canceled="serviceCanceled"
      @close="openModal = false"
  ></cancel-service-modal>

  <rpm-modal
      header="Atualizar Dados Pessoais"
      class="grid grid-cols-12 gap-x-6 gap-y-8"
      :open="personalDataModalOpen"
      @close="personalDataModalOpen = false"
  >
    <person-form
      :errors="errors"
      :form="selectedPerson"
    ></person-form>

    <div class="flex flex-row gap-x-6 items-center justify-center col-span-12">
      <rpm-button
          label="Fechar"
          color="gray"
          @click="personalDataModalOpen = false"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          color="theme"
          @click="update"
      ></rpm-button>
    </div>
  </rpm-modal>

  <rpm-modal :open="passwordModalOpen" header="Alterar senha" class="grid grid-cols-12 gap-x-6 gap-y-8">
    <rpm-input
        label="Nova senha"
        placeholder="Nova senha"
        required
        type="password"
        :errors="errors['password']"
        v-model="form.password"
        class="col-span-6"
    ></rpm-input>

    <rpm-input
        label="Confirmação de senha"
        placeholder="Confirmação de senha"
        required
        type="password"
        v-model="form.password_confirmation"
        class="col-span-6"
    ></rpm-input>

    <div class="flex flex-row gap-x-6 items-center justify-center col-span-12">
      <rpm-button
          label="Fechar"
          color="gray"
          @click="passwordModalOpen = false"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          color="theme"
          @click="changePassword"
          :loading="loading"
      ></rpm-button>
    </div>
  </rpm-modal>

  <rpm-modal
    header="Atualizar Endereço"
    class="grid grid-cols-12 gap-x-6 gap-y-8"
    :open="addressModalOpen"
    @close="addressModalOpen = false"
  >
    <address-form
      :address="selectedPerson.address ?? addressForm"
      :errors="errors"
    ></address-form>


    <div class="flex flex-row gap-x-6 items-center justify-center col-span-12">
      <rpm-button
          label="Fechar"
          color="gray"
          @click="addressModalOpen = false"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          color="theme"
          @click="handleAddressAction"
          :loading="loading"
      ></rpm-button>
    </div>
  </rpm-modal>
</template>


<script>

import Badge from "#components/Badge.vue";
import RpmCardList from "#components/RpmCardList.vue";
import RpmModal from "#components/RpmModal.vue";
import PersonForm from "../form";

import AddressForm from '#views/address/form';
import CancelServiceModal from '#views/service/modals/cancel.vue';

import personRepository from "#repositories/personRepository";
import serviceRepository from "#repositories/serviceRepository";
import addressRepository from "#repositories/addressRepository";
import {request} from "#repositories/repository";

import {formatDate} from "#functions/formatter.js";
import {getErrors} from "#functions/validator.js"

export default {
  name: "PersonShow",
  components: {
    RpmCardList,
    Badge,
    PersonForm,
    AddressForm,
    RpmModal,
    CancelServiceModal
  },
  data() {
    return {
      selectedPerson: {},
      services: [],
      servicesLoading: false,
      personalDataModalOpen: false,
      addressModalOpen: false,
      passwordModalOpen: false,
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: []
      },
      form: {},
      openModal: false,
      selectedService: {},
      loading: false,
      errors: {},
      addressForm: {}
    }
  },
  props: {id: {}},
  methods: {
    formatDate(...params) {
      return formatDate(...params);
    },
    async getPerson() {
      this.selectedPerson = (await personRepository.getPerson(this.$route.params.id)).data;
    },
    async getServices(page = 0) {
      if (!isNaN(page) && 0 != page) this.pagination.page = page;

      this.servicesLoading = true;
      this.services = request.pagination(
          await serviceRepository.getPersonServices(this.selectedPerson.id, this.pagination),
          this.pagination
      );
      this.servicesLoading = false;
    },
    timeLineNode(procedure, idx) {
      if (idx > 0)
        return 'border-green-500 rounded-full';
      return [
        'rounded',
        procedure.executed_at ? 'border-green-500' : 'border-red-500'
      ];
    },
    modalOpen(item) {
      this.openModal = true
      this.selectedService = item
    },
    async serviceCanceled(event) {
      this.openModal = event
      await this.getServices();
    },
    async update() {
      this.loading = true;
      personRepository.updatePerson(this.selectedPerson.id, this.selectedPerson).then((response) => {
        this.getPerson();
        this.$notify(response.message, response.severity);
        this.personalDataModalOpen = false;
        }).catch((response) => {
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.getPerson();
          this.loading = false;
        });
    },

    changePassword() {
      this.loading = true
      this.form.user_id = this.selectedPerson.user.id
      personRepository.changePasswordUser(this.form).then((response) => {
        this.passwordModalOpen = false
        this.form = {
          password: '',
          password_confirmation: ''
        }
        this.loading = false
        this.$notify('Senha alterada com sucesso', 'success')
      }).catch((response) => {
        this.$notify('Ocorreu um erro,', 'error');
        getErrors(this.errors, response.errors);
        this.loading = false
      })
    },
    changeAddress() {
      this.loading = true
      addressRepository.updateAddress(this.selectedPerson.address.id, this.selectedPerson.address).then((response) => {
        this.addressModalOpen = false
        this.$notify('Endereço atualizado com sucesso.', 'success')
      }).catch((response) => {
        this.$notify('Houve um erro na atualização de endereço', 'error');
        getErrors(this.errors, response.errors);
      }).finally(() => {
        this.loading = false
      })
    },
    saveAddress() {
      personRepository.addAddress(this.selectedPerson.id, this.addressForm).then(async (response) => {
        await this.getPerson()
        this.$notify('Endereço criado com sucesso.', 'success')
        this.addressModalOpen = false
      }).catch((response) => {
        this.$notify('Ocorreu um erro', 'error');
        getErrors(this.erorrs, response, errors)
      })
    },
    handleAddressAction() {
      if (!this.selectedPerson.address) {
        this.saveAddress()
      } else {
        this.changeAddress()
      }
    },
    toFunctions() {
      this.$router.push({
        name: "Functions"
      })
    }
  },
  async mounted() {
    await this.getPerson();
    await this.getServices();
  },
};

</script>
